import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import css from './style.module.scss';
interface Props {
  text: string;
}
const Label: FC<Props> = t0 => {
  const $ = _c(2);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = <span className={css.label}>{text}</span>;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Label;